var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsCircleCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 476 476",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.667 247.917L218.167 307.417L317.333 188.417",
    className: "svgStroke",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M238 436.333C347.536 436.333 436.333 347.537 436.333 238C436.333 128.464 347.536 39.6667 238 39.6667C128.463 39.6667 39.6666 128.464 39.6666 238C39.6666 347.537 128.463 436.333 238 436.333Z",
    className: "svgStroke",
    strokeWidth: 30
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsCircleCheck2);
export default __webpack_public_path__ + "static/media/akar-icons_circle-check2.b30a78d7.svg";
export { ForwardRef as ReactComponent };